import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

import {PostConfirmPhone, PostConfirmPhoneParams, PostConfirmPhoneResponse} from 'domain/usecases';

export class RemotePostConfirmPhone implements PostConfirmPhone {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostConfirmPhoneResponse>,
	) {}

	async post(params: PostConfirmPhoneParams): Promise<PostConfirmPhoneResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
